<script>
    import Dropdown from '@js/components/themes/Dropdown.svelte';
    import Checkbox from '@js/components/themes/Checkbox.svelte';
    import Slider from '@js/components/themes/Slider.svelte';

    const {
        type,
        name,
        elementId,
        elements,
        elementFormatter,
        selectedElements,
        step,
        active = false,
        onFilterChange
    } = $props();

    const onCheckboxChange = (element, event) => {
        onFilterChange(type, elementId, element, event.target.checked);
    };

    const onSliderChange = (range) => {
        onFilterChange(type, elementId, range);
    };

    const onRadioChange = (element) => {
        onFilterChange(type, elementId, element);
    };
</script>

<!-- A compact chip: tinted once the filter narrows the results -->
<Dropdown color="chip"
          closeClickInside={type === 'radio'}
          buttonClass={active
              ? 'rounded-full! px-3! py-1! text-xs! font-semibold text-primary-800 bg-primary-50 border-primary-300 hover:bg-primary-100'
              : 'rounded-full! px-3! py-1! text-xs! font-medium text-gray-600 bg-white border-gray-200 hover:bg-gray-50'}
          buttonName={name}>
    {#if type === 'select'}
        <ul class="p-3 space-y-3 text-sm text-gray-700 dark:text-gray-200">
            {#each elements as element (element.id)}
                <li>
                    <Checkbox color="primary"
                              checked={selectedElements.has(element.id)}
                              disabled={element.count === 0 && !selectedElements.has(element.id)}
                              onchange={onCheckboxChange.bind(this, element)}>
                        {element.name}
                        <span class="text-gray-500">({element.count})</span>
                    </Checkbox>
                </li>
            {/each}
        </ul>
    {:else if type === 'range'}
        <div class="w-64 px-4 pt-3 pb-6">
            <Slider color="primary"
                    min={parseFloat(elements[0])}
                    max={parseFloat(elements[1])}
                    step={step || Math.max(1, Math.round((parseFloat(elements[1]) - parseFloat(elements[0])) / 100))}
                    marks={[
                             parseFloat(elements[0]),
                             parseFloat(elements[1])
                         ]}
                    initialValue={Array.from(selectedElements).map((element) => parseFloat(element))}
                    valueLabelFormat={(value) => (elementFormatter ? elementFormatter(value) : value)}
                    onChange={onSliderChange}/>
        </div>
    {:else if type === 'radio'}
        <!-- One choice among toggle buttons: no listbox, whose options would need arrow-key handling -->
        <div class="flex flex-col py-1 text-sm text-gray-700"
             role="group"
             aria-label={name}>
            {#each elements as element (element.id)}
                <button type="button"
                        class="w-full px-4 py-2 text-left whitespace-nowrap hover:bg-gray-100"
                        class:font-semibold={selectedElements === element.id}
                        class:text-primary-800={selectedElements === element.id}
                        aria-pressed={selectedElements === element.id}
                        onclick={() => onRadioChange(element.id)}>
                    {element.name}
                </button>
            {/each}
        </div>
    {/if}
</Dropdown>
